import * as React from "react";
import { Button, ButtonProps } from "antd-mobile";

interface GluceraButtonProps extends ButtonProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const GluceraButton: React.FC<GluceraButtonProps> = ({
  children,
  style,
  className,
  ...props
}) => {
  return (
    <Button
      {...props}
      className={className}
      style={{
        background:
          "repeating-linear-gradient(0deg, #B9E684, #B9E684 8px, #B9E684 8px, #B9E684 16px)",
        color: "#000",
        borderRadius: 8,
        fontWeight: 700,
        fontSize: 18,
        border: "none",
        boxShadow: "none",
        width: 190,
        maxWidth: "100%",
        ...style,
      }}
    >
      {children}
    </Button>
  );
};

export default GluceraButton;
